export function invoiceHeader(t) {
  return [
    {
      title: "N°",
      width: 15,
      align: "left",
      filed: "booking_number",
    },
    {
      title: "service",
      width: 10,
      align: "left",
      filed: "service",
    },
    {
      title: "",
      width: 20,
      align: "left",
      filed: "product_name",
    },
    {
      title: "checkin",
      width: 8,
      align: "left",
      filed: "checkin",
    },
    {
      title: "checkout",
      width: 8,
      align: "left",
      filed: "checkout",
    },
    { title: "", width: 5, align: "center", filed: "currency" },
    {
      title: "amount",
      width: 8,
      align: "right",
      filed: "amount",
    },
    {
      title: "solde",
      width: 8,
      align: "right",
      filed: "solde",
    },
  ];
}

export function newInvoicetNavItems(t) {
  return [
    {
      id: "refresh",
      title: t("refresh"),
      action: "method",
      element: "component",
      icon: "RefreshCcw",
      deleteIfpaid: 1,
    },
    {
      id: "xsl_new_invoice",
      title: t("Excel"),
      action: "method",
      element: "component",
      icon: "FileSpreadsheet",
      deleteIfpaid: 0,
    },

    {
      id: "save_invoice",
      title: t("save"),
      action: "method",
      element: "component",
      icon: "Save",
      deleteIfpaid: 1,
    },

    {
      id: "refresh_max_amount",
      title: t("save"),
      action: "method",
      element: "component",
      icon: "BadgeDollarSign",
      deleteIfpaid: 1,
    },
    {
      id: "totalinvoice",
      title: t("total"),
      action: "method",
      element: "component",
      icon: "total",
      deleteIfpaid: 0,
    },
    {
      id: "formnewinvoice",
      title: t("search"),
      action: "method",
      element: "ipopover",
      icon: "search",
      deleteIfpaid: 0,
    },
  ];
}

export function invoicetNavItems(t) {
  return [
    {
      id: "refresh",
      title: t("refresh"),
      action: "method",
      element: "component",
      icon: "RefreshCcw",
      deleteIfpaid: 1,
    },
    {
      id: "xsl_invoice",
      title: t("Excel"),
      action: "method",
      element: "component",
      icon: "FileSpreadsheet",
      deleteIfpaid: 0,
    },
    {
      id: "pdf_invoice",
      title: t("Pdf"),
      action: "method",
      element: "component",
      icon: "FileSpreadsheet",
      deleteIfpaid: 0,
    },

    {
      id: "save_invoice",
      title: t("save"),
      action: "method",
      element: "component",
      icon: "Save",
      deleteIfpaid: 1,
    },

    {
      id: "refresh_max_amount",
      title: t("save"),
      action: "method",
      element: "component",
      icon: "BadgeDollarSign",
      deleteIfpaid: 1,
    },
    {
      id: "totalinvoice",
      title: t("total"),
      action: "method",
      element: "component",
      icon: "total",
      deleteIfpaid: 0,
    },
  ];
}
